define([
    'jquery',
    'handlebars-core',
    'pubsub',
    'wcs.product-views',
    'wcs.product-views-util',
    'shared.main.plugins',
    "wcs.utils",
    'shared.main.screen'
], function ($, HandlebarsCore, pubsub, pdp, pdpUtil, pluginLoader, utils, screenSize) {

// Name the plugin
    var PLUGIN_IDENTIFIER = 'inlineQuickView',
        DEBUG = false,
        selectedFacets = [];

// Create the function that will be bound to JQuery
    var vfdpPlugin = function (element, options) {
        this.element = element;
        this.options = options;
    };

// Define the plugin's prototype and defaults
    vfdpPlugin.prototype = {
        defaults: {
            'targetContainer': '.product-block-js',
            'template': 'html.inline-quick-view.inline-quick-view',
            'buttonTargetContainer': '.product-block-info.info-js',
            'swatchTargetContainer': '.product-block-color-swatches-container.swatches-container',
            'iconShop': 'icon-cart-plus',
            'iconClose': 'icon-close',
            'buttonSelector': '.inline-quick-view-button',
            'quickViewContainer': '.inline-quick-view-container',
            'quickViewSizeLabelAttribute': 'data-quick-view-size-label',
            'quickViewSizeLabelDefaultValue': 'SIZE',
            'ajaxInButton': false,
            'targetResultContainer': '.product-panel-results',
            'addToBagButton': '.quickview-box-js .add-to-bag-js',
            'errorMessage': '.quickview-box-js .error',
        },

        /**
         * Initializes the plugin instance
         * @returns {Object} This plugin instance
         */
        init: function () {
            var self = this;

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + 'Options');
            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata // options provided as HTML data attribute $(selector).data()
            );
            self.isErrorMessageEnabled = true;

            // Initialize events
            self.events();

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        /**
         * Binds plugin events
         **/
        events: function () {
            var self = this;
            var $document = $(document);

            var $swatchContainer = $(self.config.swatchTargetContainer);

            $document.on('click', self.config.buttonSelector, self.openInlineQuickView.bind(self));

            self.$swatchSelectors = $swatchContainer.find('div');
            self.$swatchSelectors.on('click', self.updateInlineQuickView.bind(self));

            $.pubsub('subscribe', 'vfdp.viewLayoutSwitch.toggled', function(event,data) {
                if(self.isInlineQuickViewOpen) {
                    self.$xhr.abort();
                    self.closeInlineQuickView(self.$quickViewContainer, self.$icon);
                }
            });

            // Reset selected facets when DOM is updated
            $.pubsub('subscribe', 'PLP.FACET.RESET', function () {
              selectedFacets = [];
            });

            // Listen to selected facet and store it
            $.pubsub('subscribe', 'PLP.FACET.SELECTED', function (msg, event) {
              var $facet = $(event.facet);
              self.storeSelectedFacet($facet);
            });

            $.pubsub('subscribe', 'SHOPCART_UPDATED.add', function (event, data) {
                self.closeInlineQuickView(self.$quickViewContainer, self.$icon);
            });

            function updateErrorMessage() {
                if ($('.attr-box.clicked.out-of-stock').length) {
                    if (self.isErrorMessageEnabled) {
                        $(self.config.errorMessage + '.hide').removeClass('hide');
                    }
                } else  {
                    $(self.config.errorMessage + ':not(.hide)').addClass('hide');
                }

                self.isErrorMessageEnabled = false;
            }

            $.pubsub('subscribe', 'WCS.PRODUCTFORM.CURRENT_SELECTION.HAS_INVENTORY', updateErrorMessage);
            $.pubsub('subscribe', 'WCS.PRODUCTFORM.CURRENT_SELECTION.NOT_HAS_INVENTORY', updateErrorMessage);
            $document.on('click', self.config.addToBagButton, function () {
                self.isErrorMessageEnabled = true;
                updateErrorMessage();
            });
        },

        updateInlineQuickView: function(event){
            if (DEBUG) console.log('updateInlineQuickView');
            var self = this;
            var $selectedColorSwatch = $(event.target).parent();
            self.$productBlock = $selectedColorSwatch.closest(self.config.targetContainer);
            var $quickshopUrl = self.$productBlock.find('.quickshop-js');
            var colorSwatchId = $selectedColorSwatch.attr('id');
            var $selectorSwatch = $("span[data-variation-id='" + colorSwatchId + "']").parent();
            $selectorSwatch.on('click');

            // updating quickview ajax url
            var quickviewUrl = $quickshopUrl.data('ajax');
            if(quickviewUrl){
                $quickshopUrl.data('ajax', quickviewUrl.replace(RegExp('variationId=\\d+'), 'variationId='+colorSwatchId));
            }
        },

        /**
         * Start procedure for opening a inline quick view - checkes what type of event (open/close or new type of product was clicked) and then initite an ajax an opening or closing of the already opened.
         **/
        openInlineQuickView: function(event) {
            var self = this;
            var $button = $(event.target);
            var $icon = $button;
            if ($button.is("span")) {
                $button = $button.parent();
            }
            else {
                $icon = $button.find('span');
            }
            var $ctaButton = $button;
            var previousButton = self.$button; // saving the previous clicked quick view button, so it can be differentiated was it a new quick view opened, or the existing one
            self.$button = $button;
            self.$icon = $icon;
            self.$productBlock = $button.closest(self.config.targetContainer);
            self.$resultsView = self.$productBlock.closest(self.config.targetResultContainer);
            self.$quickViewContainer = self.$productBlock.find(self.config.quickViewContainer);

            var $swatchContainer = self.$productBlock.find('.color-swatches-js');
            self.adjustInlineQuickViewPosition($swatchContainer);

            $(self.config.targetResultContainer).removeClass('inline-quick-view--expanded').removeAttr('style');

            // Workaround until we have the BE adding the attribute in the markup automatically
            var sizeLabel = self.$quickViewContainer.attr(self.config.quickViewSizeLabelAttribute);
            if (!sizeLabel) {
              self.$quickViewContainer.attr(self.config.quickViewSizeLabelAttribute, self.config.quickViewSizeLabelDefaultValue);
            }

            if ($ctaButton.attr('aria-expanded') === 'false') {

                if (previousButton && previousButton[0] !== self.$button[0]) { // Checking if the previous button is different than the current selected one. If it is a different, the the current quick view should be closed, and a new oneopened
                    // close the previous quick view
                    // var $previousInline = previousButton.parent().parent().find(self.config.quickViewContainer);
                    var $previousInline = previousButton.closest(self.config.targetContainer).find(self.config.quickViewContainer);
                    self.closeInlineQuickView($previousInline, previousButton.find('span'));
                }
                var $selectedColorSwatch = self.$productBlock.find('.product-block-info .product-block-color-swatch.swatch-js.selected-js');
                self.variationId = null;
                if( $selectedColorSwatch.length > 0 ){
                    self.variationId = $selectedColorSwatch.data().variation;
                }

                var data = self.$productBlock.find('.product-block-view > .quickshop-js').data();
                if( self.config.ajaxInButton) {
                    data =  $ctaButton.data();
                }

                if (data.openAjax) {
                    self.config.url = data.openAjax;

                    if( self.variationId ){
                        self.config.url = utils.setURLParam(data.openAjax, 'variationId', self.variationId);
                    }

                    self.$xhr = $.ajax({
                        url: self.config.url,
                        complete: function(xhr, status) {
                            if(DEBUG) console.log('ajax complete: ', status);
                        },
                        type: 'POST'
                    }).done(self.insertInlineView.bind(self))
                        .fail(function (err) {
                            if(DEBUG) console.error("AJAX FAIL: ", err);
                        });
                }
                $icon.removeClass(self.config.iconShop).addClass(self.config.iconClose);
                self.$button.attr('aria-expanded', true);
                self.$productBlock.addClass('inline-quick-view--active');
                self.$resultsView.addClass('inline-quick-view--expanded');
            }
            else {
                self.closeInlineQuickView(self.$quickViewContainer, $icon);
            }

            // Listen to more swatches toggle and reposition inline quickview container
            self.toggleMoreListener = $.pubsub('subscribe', 'PLP.SWATCH.TOGGLE_MORE', function (msg, event) {
              var $swatchContainer = $(event.container);
              self.adjustInlineQuickViewPosition($swatchContainer);
            });

            self.isInlineQuickViewOpen = true;
        },

        /**
        * Retrieves previously stored facets
        **/
        retrieveStoredSelectedFacets: function ($quickview) {
          var $selectedProduct = $quickview.closest('.product-panel'),
              $selectionContainer = $selectedProduct.find('.selection-js'),
              productId = $selectionContainer.data('product-id');

          var hasSelectedFacets = selectedFacets.find(function (facet) {
            return facet.productId == productId;
          });

          if (hasSelectedFacets) {
            var $facets = $selectedProduct.find('.attr-box');
            var product = hasSelectedFacets;
            $facets.removeClass('clicked');
            for (var key in product) {
              if (key !== 'productId') {
                var $facetItem = $selectedProduct.find('[data-attribute-value="' + product[key] + '"]');
                $facetItem.addClass('clicked selected');
              }
            }
          }
        },

        /**
        * Stores selected facet
        * @param {Object} $facet - selector for selected facet
        **/
        storeSelectedFacet: function ($facet) {
          var $facetContainer = $facet.closest('.selection-js'),
              productId = $facetContainer.data('product-id'),
              facetType = $facetContainer.hasClass('attr-color') ? 'color' : 'size',
              facetValue = $facet.data('attribute-value'),
              productObj = {};

          if (selectedFacets.length) {
            var storedProduct = selectedFacets.find(function (facet) {
              return facet.productId == productId;
            });

            if (storedProduct) {
              storedProduct[facetType] = facetValue;
            } else {
              productObj[facetType] = facetValue;
              productObj.productId = productId;
              selectedFacets.push(productObj);
            }
          } else {
            productObj[facetType] = facetValue;
            productObj.productId = productId;
            selectedFacets.push(productObj);
          }
        },

        /**
        * Adjust inline quick view position based on color swatch container state (collapsed/expanded).
        * @param {Object} $swatchContainer - selector for the swatches container
        **/
        adjustInlineQuickViewPosition: function ($swatchContainer) {
            var self = this,
                $productBlock = $swatchContainer.closest(self.config.targetContainer),
                $activeQuickview = $productBlock.find('.inline-quick-view'),
                productBlockHeight = $productBlock.innerHeight(),
                productBlockMarginBottom = parseInt($productBlock.css('marginBottom')),
                swatchesHeight = $swatchContainer.height();

            // Use different spacing approach for mobile and desktop
            if (screenSize.size() === 'small') {
              swatchesHeight = $swatchContainer.outerHeight(true);
              $activeQuickview.css('marginTop', swatchesHeight);
            } else {
              $activeQuickview.css('top', productBlockHeight + swatchesHeight - productBlockMarginBottom);
            }
        },

        /**
         * Close inline quick view.
         * @param {Object} $quickViewContainer - selector for the container for the quickview to be closed
         * @param {Object} $icon - selector for the button in the container (to change the icon)
         **/
        closeInlineQuickView: function ($quickViewContainer, $icon) {
            var self = this,
                $productBlock = $icon.closest(self.config.targetContainer);
            $quickViewContainer.empty();
            $icon.removeClass(this.config.iconClose).addClass(this.config.iconShop);
            $icon.parent().attr('aria-expanded', false);
            $productBlock.removeClass('inline-quick-view--active');
            self.$resultsView.removeClass('inline-quick-view--expanded').removeAttr('style');
            $.pubsub('unsubscribe', self.toggleMoreListener);
            delete window.productFormState;
            self.isInlineQuickViewOpen = false;
        },

        insertInlineView: function (html) {
            this.$quickViewContainer.empty();
            var quickView = $(html).filter('.quickview-box-js');

            var strippedQuickView = quickView.find('.product-content-container');
            strippedQuickView.find('.product-content-info-container').children('.product-info-js, .pr-review-snippet-rating').remove();
            quickView.html(strippedQuickView[0]);

            this.$quickViewContainer.html(quickView);
            this.initQuickViewContent(this.$quickViewContainer);

            this.retrieveStoredSelectedFacets(this.$quickViewContainer);

            //get our tracking analytics
            var trackingData = $(html).filter('.tracking-product-data-js');
            if(trackingData.length) pluginLoader.runVFDPPlugins(trackingData);
        },

        /**
         * Initiate the PDP modules associated with form validation, swatches and etc.
         * @param {Object} $quickViewContainer - selector for the container for the quickview to be closed
         **/
        initQuickViewContent: function ($quickViewContainer) {
            if (DEBUG) console.log('QuickView - Init QuickView Form');

            this.isErrorMessageEnabled = false;

            $(document).trigger( 'QUICKSHOP_DISPLAY');
            $.pubsub('publish', 'WCS_QUICKSHOP_OPENED', {quickview: $quickViewContainer, url: this.config.url});

            pluginLoader.runVFDPPlugins($quickViewContainer);
            pdp.setupQuickshop();
            pdp.handleContextChangeQuickshop();
            main.update();
        }
    };

// Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;
    vfdpPlugin.prototype = $.extend({}, HandlebarsCore, vfdpPlugin.prototype);

// Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function (options) {
        return this.each(function () {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if (!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };
});
